/*
 *
 * Authorization API Selectors
 *
 */

import { createSelector } from 'reselect';
import { NAMESPACE } from './constants';

const selectService = (state) => state[NAMESPACE];

const selectStatus = createSelector(selectService, (service) => service.status);

const selectParams = createSelector(selectService, (service) => service.params);

const selectResults = createSelector(selectService, (service) => service.results);

const selectError = createSelector(selectService, (service) => service.error);

export {
  selectStatus,
  selectParams,
  selectResults,
  selectError,
};



// WEBPACK FOOTER //
// ./src/services/SsoLogin/selectors.js